module.exports = __webpack_public_path__ + "img/database-light.91f36f97.svg";